import { useEffect, useState } from 'react';
import InfoModal from '../../../shared/components/InfoModal';
import EnvioDetalleModal from './components/EnvioDetalleModal';
import { useDispatch, useSelector } from 'react-redux';
import { resetShippingResults } from '../../../../../../redux/envios';
import { EnviosCharts } from './components/EnviosCharts';
import { CardItemSkeleton } from '../CardItemSkeleton';
import { EnviosResumenGeneral } from './components/EnviosResumenGeneral';

export default function EnviosMetrics({ data, getShippingByState }) {
    const { isLoading } = useSelector((state) => state.envios);
    const loading = useSelector((state) => {
        return state.loading;
    });
    const shippingResults = useSelector((state) => {
        return state.envios.shippingResults;
    });
    const [isOpenDetalle, setIsOpenDetalle] = useState(false);
    const [currentDetail, setCurrentDetail] = useState(null);

    const dispatch = useDispatch();

    const handleOpenDetalle = (detailToOpen) => {
        if (detailToOpen.isDisabled) {
            return;
        }
        setCurrentDetail(detailToOpen);
        const { estadoId, isNacional } = detailToOpen;
        getShippingByState(estadoId, isNacional, 1);
    };
    const handleCloseDetalle = () => {
        setCurrentDetail(null);
        dispatch(resetShippingResults());
        setIsOpenDetalle(false);
    };

    const getShippingNewPage = (newPage) => {
        const { estadoId, isNacional } = currentDetail;
        getShippingByState(estadoId, isNacional, newPage);
    };

    const getClassFlag = (state, type) => {
        if (state.estado_id !== 4) {
            return '';
        }
        if(!state[`fecha_${type}_mas_antigua`]) {
            return '';
        }
        if (isOlderThanBusinessDays(state[`fecha_${type}_mas_antigua`], 5)) {
            return ' flag5dias';
        }
        if (isOlderThanBusinessDays(state[`fecha_${type}_mas_antigua`], 3)) {
            return ' flag3dias';
        }
        return '';
    };

    function isOlderThanBusinessDays(dateStr, businessDaysAgo) {
        const inputDate = new Date(dateStr);
        const today = new Date();

        // Quitar la parte de hora para comparar solo fechas
        inputDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        let businessDaysCount = 0;
        let datePointer = new Date(today);

        while (businessDaysCount < businessDaysAgo) {
            datePointer.setDate(datePointer.getDate() - 1);
            const day = datePointer.getDay();
            // 0 = Domingo, 6 = Sábado
            if (day !== 0 && day !== 6) {
                businessDaysCount++;
            }
        }

        return inputDate < datePointer;
    }

    useEffect(() => {
        if (!isOpenDetalle && currentDetail && !loading) {
            setIsOpenDetalle(true);
        }
    }, [isOpenDetalle, loading, currentDetail]);

    return (
        <div className="w-100 d-flex flex-column align-items-center justify-content-between my-3 envios-metrics">
            <div className="card-grid w-100 d-flex flex-wrap gap-2">
                <h2 className="subtitle mt-2">Nacional</h2>
                {!isLoading ? (
                    data?.map((state) => {
                        if (state.estado_id !== 7) {
                            return (
                                <div
                                    className="card-item d-flex flex-column align-items-center"
                                    key={state.estado_id}
                                >
                                    <h2>{state.nombre}</h2>
                                    <h1
                                        className={`${
                                            state?.count_nacional === 0
                                                ? 'disabled-link'
                                                : 'link'
                                        }${getClassFlag(state, 'nacional')}`}
                                        onClick={() =>
                                            handleOpenDetalle({
                                                estadoId: state.estado_id,
                                                estadoNombre: state.nombre,
                                                isNacional: true,
                                                isDisabled:
                                                    state?.count_nacional === 0,
                                            })
                                        }
                                    >
                                        {state?.count_nacional}
                                    </h1>
                                </div>
                            );
                        }
                        return '';
                    })
                ) : (
                    <>
                        {Array.from({ length: 8 }).map((_, i) => (
                            <CardItemSkeleton key={i} />
                        ))}
                    </>
                )}
            </div>
            <div className="card-grid w-100 d-flex flex-wrap gap-2">
                <h2 className="subtitle mt-5">Internacional</h2>
                {!isLoading ? (
                    data?.map((state) => {
                        if (state.estado_id !== 7) {
                            return (
                                <div
                                    className="card-item d-flex flex-column align-items-center"
                                    key={state.estado_id}
                                >
                                    <h2>{state.nombre}</h2>
                                    <h1
                                        className={`${
                                            state?.count_internacional === 0
                                                ? 'disabled-link'
                                                : 'link'
                                        }${getClassFlag(
                                            state,
                                            'internacional'
                                        )}`}
                                        onClick={() =>
                                            handleOpenDetalle({
                                                estadoId: state.estado_id,
                                                estadoNombre: state.nombre,
                                                isNacional: false,
                                                isDisabled:
                                                    state?.count_internacional ===
                                                    0,
                                            })
                                        }
                                    >
                                        {state?.count_internacional}
                                    </h1>
                                </div>
                            );
                        }
                        return '';
                    })
                ) : (
                    <>
                        {Array.from({ length: 8 }).map((_, i) => (
                            <CardItemSkeleton key={i} />
                        ))}
                    </>
                )}
            </div>
            <div className="card-grid w-100 d-flex flex-wrap gap-2">
                <h2 className="subtitle mt-5">Métricas</h2>
                <EnviosCharts data={data} />
            </div>
            <div className="card-grid w-100 d-flex flex-wrap gap-2">
                <h2 className="subtitle mt-5">Resumen General</h2>
                <EnviosResumenGeneral data={data} />
            </div>

            {isOpenDetalle && (
                <InfoModal
                    state={isOpenDetalle}
                    title={`Envios ${
                        currentDetail.isNacional
                            ? 'Nacionales'
                            : 'Internacionales'
                    } Estado ${currentDetail?.estadoNombre}`}
                    width={'lg'}
                    content={
                        <EnvioDetalleModal
                            currentDetail={currentDetail}
                            getShippingNewPage={getShippingNewPage}
                            shippingResults={shippingResults}
                        />
                    }
                    onClose={handleCloseDetalle}
                />
            )}
        </div>
    );
}
